import container from "./Container";
const app = {
  type: "App",
  appCode: "17fbb28b968",
  auth: {},
  container,
};

export default app;
